import { createSelector } from "reselect"
import { getIsOpPro } from "modules/account-root/selectors"
import { filter, size, get } from "lodash"
import { OPPRO_EXPERIMENT_PER_PORTFOLIO_LIMIT } from "helpers/op-pro"

const getExperiments = state => get(state, "global.data.experiments.data")
const getPortfolioId = (state, props) => props?.portfolioId

const getPortfolioExperiments = createSelector(
  [getExperiments, getPortfolioId],
  (experiments, portfolioId) => filter(experiments, ({ resourceId }) => resourceId === portfolioId),
)

export const getExperimentLimitReached = createSelector(
  [getIsOpPro, getPortfolioExperiments],
  (isOpPro, experiments) => isOpPro && size(experiments) >= OPPRO_EXPERIMENT_PER_PORTFOLIO_LIMIT,
)
